import type {
    CrmJobsTransitionDto,
    CrmJobsTransitionProvider,
    CrmJobsTransitionStatusDto,
} from "../types/crmJobsTransition";
import { crmJobsTransitionProviderMap } from "../types/crmJobsTransition";

const CRM_JOBS_TRANSITION_PROVIDERS: readonly CrmJobsTransitionProvider[] = [
    crmJobsTransitionProviderMap.salesforce,
    crmJobsTransitionProviderMap.hubspot,
];

const hasPendingCrmJobsTransition = (status?: CrmJobsTransitionStatusDto): boolean =>
    status?.fieldMappingsTransition === true || status?.crmJobsTransition === true;

export const hasAnyPendingCrmJobsTransition = (dto?: CrmJobsTransitionDto): boolean => {
    if (!dto) {
        return false;
    }

    return CRM_JOBS_TRANSITION_PROVIDERS.some((provider) => hasPendingCrmJobsTransition(dto[provider]));
};

export const getFirstCrmWithPendingJobsTransition = (
    dto?: CrmJobsTransitionDto,
): CrmJobsTransitionProvider | undefined =>
    CRM_JOBS_TRANSITION_PROVIDERS.find((provider) => hasPendingCrmJobsTransition(dto?.[provider]));

export const hasFieldMappingsTransition = (
    dto: CrmJobsTransitionDto | undefined,
    provider: CrmJobsTransitionProvider,
): boolean => dto?.[provider]?.fieldMappingsTransition === true;

export const hasCrmJobsTransition = (
    dto: CrmJobsTransitionDto | undefined,
    provider: CrmJobsTransitionProvider,
): boolean => dto?.[provider]?.crmJobsTransition === true;
